// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"ClickableCard_clickableCard__3I4yB","activeKeypress":"ClickableCard_activeKeypress__1Nu8c"};